<div class="text-sparteBlue mb-8 text-xl font-medium flex items-center">
  <mat-icon [fontSet]="outlined ? 'material-icons-outlined' : 'material-icons'">{{icon}}</mat-icon>
  <span class="uppercase ml-2">{{ currentRoute}}</span>
</div>